import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { products } from 'src/app/admin/dashboard/dashboard.data';
import { Order } from 'src/app/app.models';
import { Data, AppService } from '../../app.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  @ViewChild('horizontalStepper', { static: true }) horizontalStepper: MatStepper;
  @ViewChild('verticalStepper', { static: true }) verticalStepper: MatStepper;
  billingForm: FormGroup;
  deliveryForm: FormGroup;
  countries = [];
  months = [];
  years = [];
  deliveryMethods = []; 

  total = [];
  subTotal=[];
  cgst=[];
  grandSubTotal=[];
  grandSubTotalFinal=0;
  gstTotal=0;
  grandTotal = 0;
  cartItemCount = [];
  cartItemCountTotal = 0;
  states: any = [];

  constructor(public appService: AppService, public formBuilder: FormBuilder, private _router: Router, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.GetStates();
    debugger;
    this.appService.Data.cartList.forEach(product => {
      debugger;
      this.subTotal[product.productId] = product.cartCount * product.productPrice;
      this.total[product.productId] = this.subTotal[product.productId] + (this.subTotal[product.productId])*product.cgst/100;
      this.grandSubTotalFinal+=this.subTotal[product.productId];      
      this.gstTotal+=(this.subTotal[product.productId])*product.cgst/100;
      this.grandTotal += this.total[product.productId];
     
    });
    this.billingForm = new FormGroup({
      invoiceToAddress: new FormControl("", [Validators.required]),
      invoiceToCity: new FormControl("", [Validators.required, Validators.pattern("^[a-zA-Z]+$")]),
      invoiceToState: new FormControl("", [Validators.required]),
      invoiceToPin: new FormControl("", [Validators.required]),
      invoiceToPhone: new FormControl("", [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
      invoiceToGSTINUIN:new FormControl("",[Validators.required])
    })
    this.deliveryForm = new FormGroup({
      shipToAddress: new FormControl("", [Validators.required]),
      shipToCity: new FormControl("", [Validators.required, Validators.pattern("^[a-zA-Z]+$")]),
      shipToState: new FormControl("", [Validators.required]),
      shipToPin: new FormControl("", [Validators.required]),
      shipToPhone: new FormControl("", [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
    })
  }

  public billingAddress() {

    this.appService.getBillingAddressByUserId("api/User/GetBillingShippingAddressByUserId").subscribe((data: any) => {

      this.billingForm.patchValue(data);
    })
    error => {
      console.log(error.error.errors);
    }
  }

  public shippingAddress() {
    this.appService.getBillingAddressByUserId("api/User/GetBillingShippingAddressByUserId").subscribe((data: any) => {
      this.deliveryForm.patchValue(data);
    })
    error => {
      console.log(error.error.errors);
    }
  }

  saveOrder(orderFormValue, deliveryFormValue) {


    const orderItemList = [];
    this.appService.Data.cartList.forEach((product) => {
      orderItemList.push(product);
    });

    const order = { ...orderFormValue, ...deliveryFormValue };
    const orderModel: Order = {
      userId: 1,
      invoiceToAddress: order.invoiceToAddress,
      invoiceToState: order.invoiceToState,
      invoiceToCity: order.invoiceToCity,
      invoiceToPhone: order.invoiceToPhone,
      invoiceToGSTINUIN: order.invoiceToGSTINUIN,
      invoiceToPin: order.invoiceToPin,
      shipToAddress: order.shipToAddress,
      shipToState: order.shipToState,
      shipToCity: order.shipToCity,
      shipToPhone: order.shipToPhone,
      shipToPin: order.shipToPin,
      productTotal: this.grandSubTotalFinal,
      taxes:this.gstTotal,     
      orderTotal: this.grandTotal,
      orderItems: orderItemList,
    };

    this.appService.saveOrder("api/Order", orderModel)
      .subscribe(res => {
        this.snackBar.open('Order placed successfuly!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
        this.appService.Data.cartList = [];
        this.appService.Data.totalCartCount = 0;
        this.appService.Data.totalPrice = 0;
        //this._router.onSameUrlNavigation = 'reload';
        this._router.navigate(["/"]);
      }, error => {
        this.snackBar.open('Something went wrong!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      });

  }

  public placeOrder() {
    this.horizontalStepper._steps.forEach(step => step.editable = false);
    this.verticalStepper._steps.forEach(step => step.editable = false);
    this.appService.Data.cartList.length = 0;
    this.appService.Data.totalPrice = 0;
    this.appService.Data.totalCartCount = 0;
  }

  public GetStates() {
    this.appService.getUserById("api/State").subscribe((data: any) => {
      this.states = data;
    })
    error => {
      console.log(error.error.errors);
    }
  
  }
}
